// extracted by mini-css-extract-plugin
module.exports = {"buttonArea":"style__buttonArea__bVeoR"};